import { Component, OnInit, Input } from '@angular/core';
import { OrdenCompraService } from '../../../services/orden-compra.service';
import { OrdenCompra } from '../../../models/orden-compra';
import { ProductoService } from '../../../services/producto.service';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-orden-compra-modal',
  templateUrl: './orden-compra-modal.component.html',
  styleUrls: ['./orden-compra-modal.component.css'],
  providers: [ OrdenCompraService,ProductoService]
})
export class OrdenCompraModalComponent implements OnInit {

  @Input() orden_id: String;
  @Input() numero_decimales: number = 2;
  public orden: OrdenCompra;
  public loading = false;
  public format_decimal: String;

  constructor(
    private ordenService: OrdenCompraService,
    private productoService: ProductoService,
    public bsModalRef: BsModalRef,
  ) {
    this.orden = new OrdenCompra();
    this.format_decimal = "0,0.00";
  }

  ngOnInit() {
    let digitos = "";
    for (let i = 0; i < this.numero_decimales; i++) digitos += "0";
    this.format_decimal = "0,0." + digitos

    this.getOrdenesById();
  }

  getOrdenesById() {
    this.loading = true;
    let qs = '?embed=bodega,proveedor,detalle?embed=producto';


    this.ordenService.getById(this.orden_id, qs).subscribe(
      res => {


        this.orden = res.data;
        let qs = '?embed=unidadmedida';
        this.orden.detalle.forEach(d => {
          this.productoService.getById(d.id, qs).subscribe(
            res => {
              d.producto.unidadmedida = res.unidadmedida;
              this.loading = false;
            },
            err => {
              this.loading = false;
            }
          )
        });

      },
      err => {
        this.loading = false;
      }
    );
  }

  get formatDecimal() {
    return this.format_decimal;
  }



}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/orden-compra-modal/orden-compra-modal.component.ts